import { useState, useCallback } from "react";
import {
  getCommissions,
  getCommissionStats,
  getPaymentAttempts,
  getWalletTransactions,
} from "../../../../api/marketplace";

export function useCommissions() {
  const [commissions, setCommissions] = useState([]);
  const [stats, setStats] = useState(null);
  const [walletTransactions, setWalletTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCommissions = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getCommissions(params);
      setCommissions(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStats = useCallback(async () => {
    try {
      const res = await getCommissionStats();
      setStats(res.data);
    } catch (err) {
      console.error("Failed to fetch commission stats:", err);
    }
  }, []);

  const fetchPaymentAttempts = useCallback(async (id) => {
    const res = await getPaymentAttempts(id);
    return res.data;
  }, []);

  const fetchWalletTransactions = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getWalletTransactions(params);
      setWalletTransactions(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    commissions,
    stats,
    walletTransactions,
    loading,
    error,
    fetchCommissions,
    fetchStats,
    fetchPaymentAttempts,
    fetchWalletTransactions,
  };
}
